import moment from 'moment';

// eslint-disable-next-line consistent-return
function getNextPayDate(frequency, lastPayDayDate) {
  if (frequency === 'weekly') {
    return moment(lastPayDayDate).add(1, 'week').format('YYYY-MM-DD');
  }
  if (frequency === 'bi-weekly') {
    return moment(lastPayDayDate).add(2, 'week').format('YYYY-MM-DD');
  }
  if (frequency === 'monthly') {
    return moment(lastPayDayDate).add(1, 'month').format('YYYY-MM-DD');
  }
  if (frequency === 'semi-monthly') {
    return moment(lastPayDayDate).add(16, 'days').format('YYYY-MM-DD');
  }
}
export default getNextPayDate;
